import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { AlarmCustomersComponent } from './alarm-customers.component';
import { MdbGlobalModule } from 'src/app/shared/mdb-global.module';
import { DashboardModule } from 'src/app/shared/shared-dashboard/dashboard.module';
import { EditCustomerComponent } from '../edit-customer/edit-customer.component';
import { DxSelectBoxModule, DxTextBoxModule, DxTextAreaModule, DxFormModule, DxAutocompleteModule, DxAccordionModule, DxButtonModule, DxCheckBoxModule, DxDataGridModule, DxPopupModule, DxScrollViewModule, DxNumberBoxModule, DxDateBoxModule, DxTagBoxModule } from 'devextreme-angular';
import { NewContactComponent } from 'src/app/shared/new-contact/new-contact.component';
import { NewContactModule } from 'src/app/shared/new-contact/new-contact.module';
import { GooglePlaceModule } from 'ngx-google-places-autocomplete';
import { EditCustomerReutilizableModule } from '../edit-customer-reutilizable/edit-customer-reutilizable.module';


@NgModule({
  declarations: [
    AlarmCustomersComponent,
  ],
  imports: [
    CommonModule,
    MdbGlobalModule,
    DashboardModule,
    DxDataGridModule,
    DxButtonModule,
    DxCheckBoxModule,
    NewContactModule,
    DxScrollViewModule,
    DxPopupModule,
    DxAccordionModule,
    DxAutocompleteModule,
    DxFormModule,
    DxTextAreaModule,
    DxTextBoxModule,
    DxSelectBoxModule,
    DxNumberBoxModule,
    GooglePlaceModule,
    DxDateBoxModule,
    DxTagBoxModule,
    EditCustomerReutilizableModule
  ],
  exports:[AlarmCustomersComponent],
  entryComponents: [NewContactComponent]
})
export class AlarmCustomersModule { }
